module.exports = ['login', 'register', 'restore', 'join', 'event', 'download', 'cabinet', 'create', ''];
